module.exports = __webpack_public_path__ + "img/thinking-process-done-static.11412eb.gif";